import { en, type ChromeMessages } from "./chrome_en.ts";

/** Spanish web app chrome. Unlisted keys stay English (product names and tokens). */
export const es: ChromeMessages = {
  ...en,
  appTitle: "intEHRgrator — Banco de integración",
  copyPrompt: "Copiar prompt",
  copyPromptTitle: "Copiar el prompt de IA con los archivos incrustados",
  callAi: "Llamar a la IA",
  callAiTitle: "Llamar a la IA configurada con herramientas de mapeo (nombres MCP / API de agente)",
  aiMenuAria: "Ayuda de IA",
  menuCopyPrompt: "Copiar prompt",
  menuCallAi: "Llamar a la IA",
  menuAiCredentials: "Configurar credenciales de IA…",
  menuEmbedFiles: "Incrustar archivos en el prompt",
  menuAttachFiles: "Adjuntar archivos en el chat",
  menuBrowseUris: "Explorar URI (cuando existan)",
  menuAiCopyHeading: "copiar/pegar para chat de IA externo",
  menuAiOwnHeading: "Su propia IA",
  menuAiDesktopHeading: "Escritorio",
  menuLocalMcp: "Servidor MCP local…",
  localMcpTitle: "Servidor MCP local",
  localMcpIntro:
    "Inicie o detenga el servidor que su IDE usa para editar este lienzo. Copie la configuración en los ajustes MCP del IDE. Mantenga esta aplicación abierta.",
  localMcpRunning: "En ejecución — un IDE puede conectarse",
  localMcpStopped: "Detenido — los IDE no pueden cambiar este lienzo",
  localMcpStart: "Iniciar",
  localMcpStop: "Detener",
  localMcpUrlLabel: "URL de la API de agente",
  localMcpTokenLabel: "Token",
  localMcpNoToken: "Sin token (solo loopback)",
  localMcpConfigLabel: "Configuración del IDE (mcp.json)",
  localMcpCopy: "Copiar configuración",
  localMcpCopied: "Configuración copiada",
  localMcpUnavailable: "El servidor de escritorio no respondió.",
  menuFile: "Archivo",
  menuAi: "IA",
  importAi: "Importar sugerencias de IA",
  exampleSets: "Conjuntos de ejemplos",
  exampleSetsTitle: "Cargar un conjunto de ejemplos completo (origen, destino, mapeo opcional) desde URI del catálogo",
  exampleSetsMenuAria: "Elegir conjunto de ejemplos",
  functions: "Funciones",
  functionsTitle: "Guardar, cargar o aportar funciones de Blockly; explorar la biblioteca de funciones de GitHub",
  newProject: "Proyecto nuevo",
  loadProject: "Cargar proyecto",
  saveAs: "Guardar como",
  exportProject: "Exportar proyecto",
  importProject: "Importar proyecto",
  betterForm: "Abrir formulario Better",
  betterFormTitle: "El renderizador Better con licencia permanece en este navegador. Súbalo en el visor si aún no está.",
  help: "Ayuda",
  helpTitle: "Tutorial e informes de incidencias",
  helpMenuAria: "Menú de ayuda",
  userTutorial: "Tutorial de usuario",
  reportBug: "Informar de un error",
  requestFeature: "Pedir una función",
  uiLanguageAria: "Idioma de la interfaz",
  showSource: "Origen",
  source: "Origen",
  clickToMapAria: "Clic para mapear a Handlebars",
  clickToMapHtml:
    "Haga clic en un nodo del esquema de origen o de la instancia de ejemplo para mapearlo al bloque de Blockly seleccionado. Si hay seleccionado un bloque de texto de código (LANG = Handlebars) o un bloque de texto Handlebars, el clic inserta un {{path}} de VMS-Hbs en el cursor. Mantenga Mayús para {{#with}} / {{#each}} anidados. Si no, el modo de escucha rellena el bloque de consulta de origen que espera.",
  slideSourceAway: "Apartar Origen",
  handlebarsHint: "Inserción Handlebars lista — clic en un nodo de origen para {{path}}; Mayús+clic para #with/#each anidados.",
  schemaFormatsAria: "Formatos de esquema admitidos",
  schemaFormatsHtml:
    "Admitidos: JSON Schema, documentos JSON o XML, muestras XSD y Web Template de openEHR, Composition JSON o un .t.json de GitHub (los arquetipos se obtienen del mismo repositorio).<br>Cargue desde un archivo local, una URL o ▾ → Desde plantilla de GitHub….",
  loadSchema: "Cargar esquema",
  schemaMenuAria: "Más formas de cargar el esquema",
  examples: "Ejemplos",
  exampleFormatsAria: "Formatos de ejemplo admitidos",
  exampleFormatsHtml:
    "Admitidos: archivos de instancia JSON o XML.<br>Cargue un archivo, una carpeta local, una carpeta de GitHub (▾) o un solo archivo desde una URL.",
  addExample: "+ Añadir ejemplo",
  exampleMenuAria: "Más formas de cargar ejemplos",
  mappingEditors: "Editores de mapeo",
  undo: "Deshacer",
  redo: "Rehacer",
  expandAll: "Expandir todo",
  expandAllTitle: "Expandir todos los bloques anidados",
  collapseAll: "Contraer todo",
  collapseAllTitle: "Contraer todos los bloques anidados",
  expandChildren: "Expandir hijos",
  collapseChildren: "Contraer hijos",
  useCodedText: "Usar texto codificado (DV_CODED_TEXT)",
  usePlainText: "Usar texto simple (DV_TEXT)",
  followAgent: "Seguir al agente",
  followAgentTitle: "Si está activo, desplaza el lienzo principal a los bloques que un agente acaba de editar",
  openViewer: "Abrir ventana de visor",
  openViewerTitle: "Abrir ventana de visor: lienzo en vivo, leyenda de agentes y línea de tiempo atribuida",
  downloadJson: "Descargar JSON",
  downloadWorkspaceTitle: "Descargar el JSON completo del espacio Blockly (incluye coordenadas y diseño)",
  mappingViewsAria: "Vistas de texto del editor de mapeo",
  mappingSpec: "Especificación de mapeo",
  specLayoutAria: "Opciones de vista de la especificación",
  listView: "Vista de lista (todas las raíces)",
  tabbedView: "Vista por pestañas (por raíz)",
  download: "Descargar",
  downloadSpecTitle: "Descargar el JSON completo del espacio Blockly",
  downloadSpecAria: "Descargar el JSON completo del espacio Blockly",
  upload: "Cargar",
  uploadSpecTitle: "Cargar un archivo JSON del espacio Blockly",
  uploadSpecAria: "Cargar un archivo JSON del espacio Blockly",
  specEditorActionsAria: "Acciones del editor de especificación de mapeo",
  searchSpecTitle: "Buscar en la especificación de mapeo",
  searchSpecAria: "Buscar en la especificación de mapeo",
  copySpecTitle: "Copiar la especificación de mapeo",
  copySpecAria: "Copiar la especificación de mapeo",
  scriptEditorActionsAria: "Acciones del editor de script de conversión",
  searchScriptTitle: "Buscar en el script de conversión",
  searchScriptAria: "Buscar en el script de conversión",
  copyScriptTitle: "Copiar el script de conversión",
  copyScriptAria: "Copiar el script de conversión",
  downloadScriptAria: "Descargar script de conversión",
  testEditorActionsAria: "Acciones del editor de salida de prueba",
  searchTestTitle: "Buscar en la salida de la prueba",
  searchTestAria: "Buscar en la salida de la prueba",
  copyTestTitle: "Copiar la salida de la prueba",
  copyTestAria: "Copiar la salida de la prueba",
  downloadTestAria: "Descargar la salida de la prueba de conversión",
  markWarned: "Marcar opcionales avisados",
  markWarnedTitle: "Marcar árboles de andamiaje opcionales sin mapear que muestran un aviso de restricción",
  deleteMarked: "Eliminar marcados",
  deleteMarkedTitle: "Eliminar del lienzo los nodos marcados y sus hijos",
  undoHistoryHint: "Consejo: abra el lienzo (observador) para la línea de tiempo completa del agente y el historial atribuido.",
  undoLastEdit: "Deshacer la última edición del lienzo.",
  redoLastEdit: "Rehacer la edición del lienzo.",
  railTarget: "Esquema de destino",
  railTargetTitle: "Esquema de destino",
  railScripts: "Scripts",
  railScriptsTitle: "Scripts de conversión generados",
  railTestTitle: "Pruebas de conversión",
  targetPreviews: "Destino y vistas previas",
  targetFormatsAria: "Formatos de destino admitidos",
  targetFormatsHtml:
    "Admitidos: OPT/OPT2 de openEHR, Web Template, JSON Schema, XML Schema (XSD), ADL, plantillas libres o un .t.json de GitHub (los arquetipos se obtienen del mismo repositorio).<br>Elija juntos un destino y un mapa de contexto predeterminado. ▾ también ofrece archivo, URL, GitHub y actualización no destructiva.",
  loadTarget: "Cargar destino y mapa de contexto predeterminado",
  loadTargetTitle: "Cargar un destino y elegir un mapa de contexto predeterminado",
  targetMenuAria: "Más formas de cargar el destino",
  modelLanguageAria: "Idioma de la ontología del modelo de destino",
  scriptFormatsAria: "Formatos de script de conversión",
  scriptFormatsHtml:
    "La vista previa del mapeo interpreta el mapeo sin generar un script. Scripts de conversión (hasta ahora): TypeScript, Java, Handlebars, XQuery y Go Template. TypeScript, Handlebars, Go Template y XQuery también se ejecutan en la prueba de conversión. Java genera una clase Archie pero no se ejecuta en el web app. En destinos openEHR, la instancia JSON o XML elige cómo XQuery serializa la composición.<br>Descargar en el editor de script guarda el script generado. Descargar sobre la prueba de conversión guarda esa instancia.",
  mappingPreview: "Vista previa del mapeo",
  instance: "Instancia",
  instanceTitle: "Forma de instancia openEHR deseada. La exportación XQuery y la prueba usan esta serialización.",
  jsonInstance: "Instancia JSON",
  xmlInstance: "Instancia XML",
  slideTargetAway: "Apartar Destino y vistas previas",
  tabTargetSchema: "Esquema de destino",
  tabScripts: "Scripts de conversión generados",
  tabTest: "Pruebas de conversión",
  generatedScripts: "Scripts de conversión generados",
  downloadScriptTitle: "Descargar script de conversión",
  testRuns: "Pruebas de conversión",
  validateAs: "Validar como",
  validateTitle: "Ajuste del deserializador JSON de ehrtslib para la validación de la plantilla",
  hybrid: "Híbrido (tolerante)",
  defaultMode: "Predeterminado",
  compact: "Compacto",
  canonicalStrict: "Canónico estricto",
  terse: "Conciso",
  runTest: "Ejecutar prueba",
  autoplay: "▶ Reproducción automática",
  pause: "⏸ Pausa",
  downloadTestTitle: "Descargar la salida de la prueba de conversión",
  ready: "Listo",
  loadSchemaEmpty: "Cargue un archivo de esquema.",
  selectExampleTab: "Seleccione una pestaña de ejemplo.",
  addExamplesEmpty: 'Añada instancias de ejemplo para activar "Pruebas de conversión" en Destino y vistas previas',
  loadTargetEmpty: "Cargue un esquema o una plantilla de destino.",
  statusNoTarget: "Sin destino",
  statusTarget: "Destino: {id}",
  statusScript: "Script: {name}",
  statusNoExample: "Sin ejemplo",
  statusExample: "Ejemplo: {name}",
  statusUnmapped: "{n} obligatorios sin mapear",
  unsavedChanges: "cambios sin guardar",
  autosavedAt: "autoguardado a las {time}",
  functionsIntroHtml:
    "Guarde una función de Blockly (definición + tablas de decisión) en disco, cárguela en este mapeo o explore la biblioteca de funciones de GitHub. Aportar abre una incidencia de revisión: no se fusiona sola.",
  onThisCanvas: "En este lienzo",
  loadFromDisk: "Cargar desde disco…",
  functionLibrary: "Biblioteca de funciones",
  catalogUrl: "URL del catálogo",
  loadCatalog: "Cargar catálogo",
  close: "Cerrar",
  nameInUse: "El nombre ya está en uso",
  cancel: "Cancelar",
  replace: "Reemplazar",
  rename: "Renombrar",
  contributeTitle: "Aportar función",
  contributeIntroHtml:
    "Abre una incidencia de GitHub en <code>regionstockholm/intehrgrator</code> con su descripción y la definición de la función. Quienes mantienen el proyecto la revisan a mano.",
  functionName: "Función:",
  descriptionRequired: "Descripción (obligatoria)",
  contributePlaceholder: "Qué devuelve, idioma, tabla de decisión, parámetros…",
  needGithubHtml:
    '¿Necesita una cuenta de GitHub? <a id="function-contribute-signup" href="https://github.com/signup" target="_blank" rel="noopener noreferrer">Crear una cuenta</a> o <a id="function-contribute-login" href="https://github.com/login" target="_blank" rel="noopener noreferrer">iniciar sesión</a> y luego enviar.',
  openGithubIssue: "Abrir incidencia de GitHub",
  saveAsIntro: "Guarde el espacio de trabajo actual con un nombre que pueda cargar después.",
  projectName: "Nombre del proyecto",
  projectNamePlaceholder: "Mi proyecto de integración",
  save: "Guardar",
  loadProjectTitle: "Cargar proyecto",
  loadProjectIntro: "Seleccione un espacio guardado. Cargar sustituye el proyecto actual.",
  loadFromUrl: "Cargar desde URL",
  loadUrlHint: "Pegue una URL https. Las páginas de archivo de GitHub se convierten en contenido bruto.",
  recentUrls: "URL recientes",
  load: "Cargar",
  jointTitle: "Cargar destino y mapa de contexto predeterminado",
  jointIntroHtml:
    "Elija juntos un destino y un mapa de contexto predeterminado. Confirmar construye el <strong>esqueleto de plantilla</strong> y los <strong>puntos predeterminados</strong>. <strong>Nuevo</strong> carga el destino solo en la pestaña Esquema de destino para que pueda arrastrar fichas y valores y luego aplicar en el bloque del lienzo.",
  targetLegend: "Destino",
  noTargetYet: "Aún no hay un destino seleccionado.",
  fromFile: "Desde archivo…",
  useLoadedTarget: "Usar el destino cargado",
  targetUrl: "URL de destino",
  fetchUrl: "Obtener URL",
  mapLegend: "Mapa de contexto predeterminado",
  factoryMapHtml: "Fábrica openEHR (<code>defaults_openEHR_1</code>)",
  keepMap: "Conservar el mapa que ya está en el lienzo",
  newMap: "Nuevo (vacío) — primero el esquema de destino y luego Aplicar",
  browsedFile: "Archivo examinado",
  browseMap: "Examinar archivo de mapa…",
  loadAndScaffold: "Cargar y construir esqueleto",
  loadIntoSchema: "Cargar en el esquema de destino",
  refreshReport: "Informe de actualización",
  copyMergePrompt: "Copiar prompt de fusión",
  aiCredentialsTitle: "Credenciales de IA",
  aiCredentialsIntroHtml:
    'Punto de chat compatible con OpenAI, opcional, para que <strong>Llamar a la IA</strong> pueda mapear desde el web app. Las credenciales se quedan solo en este navegador, no en el paquete del proyecto. <strong>Llamar a la IA</strong> puede usar las mismas herramientas de mapeo que MCP / la API HTTP del agente (<code>map_slot</code>, <code>import_suggestions</code>, <code>run_test</code>, …). Un IDE asistido por IA con MCP local sigue siendo un camino aparte y válido. Páginas paso a paso: <a href="https://github.com/regionstockholm/intehrgrator/blob/main/docs/AI_CREDENTIALS.md" target="_blank" rel="noopener noreferrer" id="ai-credentials-guide">Credenciales de Llamar a la IA</a>.',
  provider: "Proveedor",
  customEndpoint: "Punto propio compatible con OpenAI",
  getApiKey: "Obtener una clave de API",
  providerDocs: "Documentación del proveedor",
  endpoint: "Punto de conexión",
  apiKey: "Clave de API",
  model: "Modelo",
  clear: "Borrar",
  defaultsTitle: "Mapa de contexto predeterminado",
  defaultsIntro: "Cargue un mapa guardado, examine un archivo o una URL, descargue el mapa de contexto predeterminado único o guarde el mapa del lienzo con un nombre.",
  browseFile: "Examinar archivo…",
  loadUrlBtn: "Cargar URL",
  downloadFile: "Descargar archivo…",
  saveAsEllipsis: "Guardar como…",
  saveDefaultsTitle: "Guardar el mapa de contexto predeterminado como",
  saveDefaultsIntro: "Guarde el mapa de contexto predeterminado actual con un nombre que pueda elegir después.",
  nameLabel: "Nombre",
  hardcodeTitle: "Fijar una entrada del mapa de contexto predeterminado",
  hardcodeIntroHtml:
    "Elija una clave del mapa para <strong>incrustarla</strong> en el lienzo. Cada búsqueda <code>get defaults key …</code> de esa clave se sustituye por una copia del valor de este mapa de contexto predeterminado. Después, esas ranuras ya no leen el argumento <code>defaults</code> en tiempo de conversión: usan el bloque fijado. El mapa en sí no cambia, para que pueda fijar otras claves más tarde.",
  importAiTitle: "Importar sugerencias de IA",
  importAiIntroHtml:
    "Pegue el JSON del chat de IA (un objeto en bruto o una valla <code>intehrgrator-suggestions</code>). La importación se valida contra el esquema JSON de sugerencias; los errores siguen visibles aquí y se pueden copiar de vuelta a la IA.",
  suggestions: "Sugerencias",
  pasteClipboard: "Pegar portapapeles",
  copyErrorsForAi: "Copiar errores para la IA",
  copied: "Copiado",
  importAction: "Importar",
  notRecommended: "No está en la versión recomendada",
  bleedingEdgeHtml:
    '¿Prefiere experimentar? La compilación más reciente (se actualiza con cada cambio en <code>main</code>) está siempre en <a id="recommended-version-bleeding-edge-link" href="#">la raíz del sitio</a>.',
  newHereHtml:
    '¿Nuevo aquí? Lea el <a id="recommended-version-tutorial-link" href="#">tutorial</a> o el <a id="recommended-version-readme-link" href="#">README</a>.',
  dontShowAgain: "No volver a mostrar esto para esta versión",
  dismiss: "Cerrar",
  defaultsBlockAria: "Acerca del mapa de contexto predeterminado",
  defaultsBlockHtml:
    "El <strong>mapa de contexto predeterminado</strong> es la tabla única que escribe aquí en el lienzo. En <em>tiempo de conversión</em>, los scripts generados lo reciben como argumento <code>defaults</code>, con clave de <strong>ejecución</strong> (<code>language</code>, <code>facility</code>, …). <code>maps_get(\"defaults\", runtimeKey)</code> las busca. El código de ejecución puede mezclar esa bolsa con valores por mensaje, otros mapas con nombre y hojas: el mapa del lienzo es la línea base reutilizable, no literales en cada ranura.<br>Los <strong>destinos de andamiaje</strong> (fichas) son solo rutas RM de autoría, no claves de ejecución: <code>Class.attribute</code> (p. ej. <code>COMPOSITION.composer</code>, <code>EVENT_CONTEXT.health_care_facility</code>), rutas de ancestros y comodines (<code>*.language</code> ilumina cada ranura de idioma). Gana la ficha más específica cuando varias coinciden. Fichas vacías → una clave solo de ejecución que no ilumina nada.<br>Confirmar, <strong>Aplicar mapa de contexto predeterminado</strong> o una actualización posterior del destino unen los <strong>puntos predeterminados</strong>. Los cambios de valor se ven en la prueba. Una ranura ya mapeada desde el origen no se sustituye.",
  decisionBlockAria: "Acerca de las tablas de decisión",
  decisionBlockHtml:
    "La <strong>tabla de decisión</strong> es una cuadrícula de reglas con nombre en Tablas y hojas: columnas de condición (igualdad, no importa <code>—</code>) y columnas de salida (valores o fragmentos VMS-Mustache). La cuadrícula posee nombres y tipos; las claves del mapa de entradas del bloque se mantienen sincronizadas.<br>Conecte a la derecha un mapa de entradas (claves = cabeceras de condición). El desplegable de salida devuelve una columna tipada (🔤 cadena, 🔢 número, ✓ booleano) o <em>todas las salidas</em> como mapa (↦). Cambiar el tipo puede desconectar el bloque; deshacer en el lienzo lo restaura.<br>La política de acierto (FIRST / UNIQUE / COLLECT) está en Tablas y hojas. Aplane los orígenes anidados en el mapa de entradas (o mediante variables) antes de evaluar.",
  fromUrl: "Desde URL…",
  refreshFromFile: "Actualizar desde archivo…",
  refreshFromUrl: "Actualizar desde URL…",
  noRecentUrls: "Aún no hay URL recientes.",
  removeFromHistory: "Quitar {url} del historial",
  enterUrl: "Introduzca una URL.",
  refreshKindFromUrl: "Actualizar {kind} desde URL",
  refreshUrlHint: "Vuelva a cargar este archivo desde una URL sin borrar los mapeos del lienzo. Los avisos listan ranuras o rutas que quizá ya no encajen.",
  kindExample: "ejemplo",
  kindTarget: "destino",
  kindSource: "origen",
  fromLocalFolder: "Desde carpeta local…",
  fromGithubFolder: "Desde carpeta de GitHub…",
  fromGithubTemplate: "Desde plantilla de GitHub…",
  loadSchemaFromUrl: "Cargar esquema desde URL",
  loadSchemaUrlHint: "JSON, XML, XSD o una plantilla .t.json de GitHub (los arquetipos se obtienen del mismo repositorio). Las páginas de archivo de GitHub se convierten en contenido bruto.",
  recentSchemaUrls: "URL de esquema recientes",
  githubTemplateTitle: "Cargar plantilla openEHR desde GitHub",
  githubTemplateHint: "Pegue una URL blob o raw de GitHub a un .t.json de Better (o .adl / .opt). Los arquetipos dependientes se toman de la misma rama.",
  githubTemplateOpenTitle: "Abrir plantilla openEHR desde GitHub",
  addExampleFromUrl: "Añadir ejemplo desde URL",
  addExampleUrlHint: "Instancia JSON o XML. Las páginas de archivo de GitHub se convierten en contenido bruto.",
  recentExampleUrls: "URL de ejemplo recientes",
  githubFolderTitle: "Añadir ejemplos desde una carpeta de GitHub",
  githubFolderHint: "Pegue una URL de árbol de GitHub a una carpeta. Se cargan todos los archivos JSON y XML de esa ruta.",
  loadTargetFromUrl: "Cargar destino desde URL",
  loadTargetUrlHint: "OPT, Web Template, JSON Schema o un .t.json de GitHub. Las páginas de archivo de GitHub se convierten en contenido bruto.",
  recentTargetUrls: "URL de destino recientes",
  loadingCatalog: "Cargando catálogo…",
  exampleSetsHeading: "Conjuntos de ejemplos",
  noExampleSets: "No hay conjuntos de ejemplos en el catálogo",
  catalog: "Catálogo",
  bundledCatalog: "Catálogo de prueba incluido",
  ehrtslibCatalog: "Catálogo ehrtslib (GitHub)…",
  loadCatalogFromUrl: "Cargar catálogo desde URL…",
  catalogUrlPrompt: "URL JSON del catálogo de conjuntos de ejemplos",
  confirmLoadExampleSet: "¿Cargar este conjunto de ejemplos? El espacio actual se sustituirá. Los cambios sin guardar pueden perderse.",
  confirmNewProject: "¿Empezar un proyecto nuevo? El espacio actual se vaciará. Los cambios sin guardar pueden perderse.",
  confirmNewEmpty: "¿Empezar un proyecto vacío?",
  confirmLoadProject: "¿Cargar este proyecto? El espacio actual se sustituirá.",
  noSavedProjects: "Aún no hay proyectos guardados. Use Guardar como o espere al autoguardado.",
  lastAutosave: "Último autoguardado",
  savedProject: "Proyecto guardado",
  defaultsUnavailable: "El catálogo de valores predeterminados no está disponible: {detail}",
  noSavedMaps: "Aún no hay mapas de contexto predeterminados guardados. Use Guardar como, Descargar, Examinar archivo o una URL.",
  savedMap: "Mapa guardado",
  noHardcodeEntries: "El mapa de contexto predeterminado aún no tiene entradas para fijar.",
  selectedFile: "Seleccionado: {name}",
  usingLoaded: "Usando el cargado: {name}",
  fetchedFile: "Obtenido: {name}",
  browsedFileLabel: "Archivo examinado: {name}",
  pasteTargetUrl: "Pegue primero una URL de destino.",
  popupBlockedSvg: "Ventana emergente bloqueada: se descargó un SVG en su lugar.",
  popupBlockedEmpty: "Ventana emergente bloqueada y el lienzo está vacío.",
  openedObserver: "Se abrió el observador del agente / instantánea del lienzo.",
  betterPopupBlocked: "No se pudo abrir el visor de formularios Better. Permita ventanas emergentes para este sitio.",
  schemaMismatch: "Desajuste de esquema:",
  conversionFailed: "La conversión falló:",
  templateValidation: "Validación de la plantilla:",
  noWorkspace: "No hay espacio de trabajo Blockly",
  noFunctionsOnCanvas: "No hay funciones en el lienzo. Extraiga a función o cargue desde la biblioteca.",
  contribute: "Aportar",
  loadCatalogBrowse: "Cargue el catálogo para explorar funciones seleccionadas.",
  catalogNoFunctions: "El catálogo no tiene funciones.",
  loadingLibrary: "Cargando la biblioteca de funciones…",
  fnReturnsValue: "{sig} → valor",
  pasteJsonFirst: "Pegue primero el JSON de la IA (o una valla intehrgrator-suggestions)",
  clipboardEmpty: "El portapapeles está vacío o no se puede leer en este navegador",
  noMatches: "Sin coincidencias",
  searchPlaceholder: "Buscar…",
  filterList: "Filtrar lista",
  historyTimeline: "Línea de tiempo del historial",
  historyIntro: "Arrastre para previsualizar; la reversión corta las entradas posteriores. Deshacer por parche devuelve JSON intehrgrator-suggestions v2.",
  seqLabel: "Sec",
  previewAtSeq: "Previsualizar en la sec",
  rollbackHere: "Revertir hasta aquí (destructivo)",
  copyPatchUndo: "Copiar prompt de deshacer por parche",
  timelineDesktopOnly: "La línea de tiempo de la API de agente solo está en la aplicación de escritorio.",
  timelineUnavailable: "API de agente no disponible: la línea de tiempo espera.",
  noHistoryYet: "Aún no hay historial.",
  selectHistoryPoint: "Seleccione un punto del historial.",
  downloadDiscardedConfirm: "¿Descargar la rama descartada (.intehrgrator) antes de continuar?",
  noBundleExport: "No hay datos de paquete que exportar para la rama descartada.",
  downloadedDiscarded: "Rama descartada descargada.",
  agentsHeading: "Agentes",
  projectLoaded: "Proyecto cargado",
  newProjectStatus: "Proyecto nuevo",
  projectNotFound: "Proyecto no encontrado",
  projectImported: "Proyecto importado",
  restoredMapping: "Se restauró el mapeo anterior",
  blocklyMustBeObject: "El JSON de Blockly debe ser un objeto",
  exampleDropJsonXml: "Soltar ejemplos: solo archivos JSON o XML",
  listeningSourceQuery: "Escuchando ruta de origen → consulta de origen",
  appliedDefaults: "Mapa de contexto predeterminado aplicado",
  refreshPromptCopied: "Prompt de fusión copiado",
  callingAi: "Llamando a la IA…",
  providerRejectedTools: "El proveedor rechazó las herramientas de mapeo; se reintenta con JSON de sugerencias…",
  aiCredentialsCleared: "Credenciales de IA borradas",
  aiCredentialsSaved: "Credenciales de IA guardadas en este navegador",
  saveAiOrCopy: "Guarde las credenciales de IA para llamar a la IA, o use Copiar prompt.",
  loadTargetFirst: "Cargue primero un destino en el esquema de destino y luego aplique el mapa de contexto predeterminado.",
  targetNodeMissing: "Ese nodo del esquema de destino no está en el destino cargado.",
  dropLeafHint: "Suelte una hoja sobre fichas de andamiaje, un subárbol sobre un zócalo de valor o sobre el lienzo vacío.",
  emptyMapReady: "Mapa de contexto predeterminado vacío listo: arrastre desde el esquema de destino y luego aplique.",
  pickTargetFirst: "Elija primero un archivo o una URL de destino.",
  corsCallAiHint: "El CORS del navegador suele bloquear proveedores en la nube desde GitHub Pages. Use la aplicación de escritorio (reenvía Llamar a la IA), active CORS en un servidor local (Ollama / LM Studio) o use Copiar prompt.",
  savedAs: 'Guardado como "{name}"',
  loadedSchema: "Esquema {name} cargado",
  loadedBlockly: "Mapeo Blockly {name} cargado",
  loadedTargetIntoSchema: "Destino {format} {id} cargado en el esquema de destino (aún sin esqueleto de producto)",
  loadedTarget: "Destino {format} {id} cargado",
  loadedFunctionLibrary: "Biblioteca de funciones cargada ({n})",
  loadedFunction: "Función {name} cargada",
  loadedExampleCatalog: "Catálogo de conjuntos de ejemplos cargado ({n} {sets})",
  setSingular: "conjunto",
  setPlural: "conjuntos",
  loadedExampleSet: 'Conjunto de ejemplos "{name}" cargado',
  exampleSetFailed: 'El conjunto de ejemplos "{name}" falló: {detail}',
  addedExample: "Ejemplo {name} añadido",
  addedExampleMismatch: "Ejemplo {name} añadido con {n} {mismatch} de esquema",
  mismatchSingular: "desajuste",
  mismatchPlural: "desajustes",
  addedExamples: "{n} ejemplos añadidos",
  addedExamplesMismatch: "{n} ejemplos añadidos con {m} {mismatch} de esquema",
  aiPromptCopied: "Prompt de IA copiado ({delivery})",
  listeningSlot: "Escuchando ruta de origen → {slot}",
  mappedWhat: "Mapeado {what}",
  mappedSourceQuery: "Consulta de origen {xpath} mapeada",
  importSummary: "Importación: {applied} aplicados, {loops} bucles, {skipped} omitidos, {errors} errores{schema}",
  importSchemaNote: ", {n} de esquema",
  importFailed: "La importación falló: {detail}",
  targetLoadFailed: "Error al cargar el destino: {detail}",
  exampleLoadFailed: "Error al cargar el ejemplo: {detail}",
  exampleFolderFailed: "Error al cargar la carpeta de ejemplos: {detail}",
  functionCatalogFailed: "El catálogo de la biblioteca de funciones falló: {detail}",
  exampleCatalogFailed: "El catálogo de conjuntos de ejemplos falló: {detail}",
  blocklyParseFailed: "No se pudo leer el JSON de Blockly: {detail}",
  couldNotLoad: "No se pudo cargar {name}: {detail}",
  autosaveFailed: "El autoguardado falló: {detail}",
  modelLanguageStatus: "Idioma del modelo: {language}",
  refreshedClean: "{kind} {name} actualizado sin conflictos de mapeo.",
  refreshedWithWarnings: "{kind} actualizado {previous} → {next}",
  warningCount: "{n} {warnings}:",
  warningSingular: "aviso",
  warningPlural: "avisos",
  loadedGithubTemplate: "Plantilla de GitHub {id} cargada ({n} archivos){extra}",
  loadedGithubSchema: "Esquema de GitHub {id} cargado ({n} archivos){extra}",
  warningsParen: " ({n} avisos)",
  callAiFailed: "Llamar a la IA falló: {detail}",
  scaffoldTarget: "Destino de andamiaje {path} (clic en la ficha para alternar *.)",
  nestedOnMap: "{label} anidado en el mapa de contexto predeterminado",
  addedMapEntry: "Entrada {key} ({path}) añadida en la fila {row}",
  addedFromTarget: "{label} añadido desde el esquema de destino",
  addedSource: "Origen {xpath} añadido",
  taskLoadGithub: "Cargar modelo clínico desde GitHub",
  taskLoadAndScaffold: "Cargar destino y construir esqueleto",
  taskLoadExampleSet: "Cargar conjunto de ejemplos",
  taskLoadTarget: "Cargar destino",
  taskLoadSchema: "Cargar esquema de origen",
  taskLoadMapping: "Cargar mapeo",
  taskLoadSheets: "Cargar hojas",
  taskLoadDefaults: "Cargar mapa predeterminado",
  taskParseUrl: "Interpretar URL de GitHub",
  taskIndexTree: "Listar archivos del repositorio",
  taskFetchFiles: "Obtener archivos del modelo clínico",
  taskParseModels: "Interpretar plantillas y arquetipos",
  taskResolveOpt: "Resolver plantilla operativa",
  taskScaffold: "Construir esqueleto de plantilla",
  taskGenerate: "Generar script de conversión",
  taskLoadExampleN: "Cargar ejemplo {n}",
  appDescription: "intEHRgrator — banco visual de integración para mapear datos de origen a openEHR",
  loadedColon: "Cargado: {name}",
  savedColon: "Guardado: {name}",
  noMappingConflicts: "Sin conflictos de mapeo.",
  refreshReportLine: "{kind} {previous} → {next}",
  refreshWarningCount: "{n} aviso(s):",
  hardcodedLookups: "Se fijó “{key}” en {n} {lookups}",
  lookupSingular: "búsqueda",
  lookupPlural: "búsquedas",
  noDefaultsLookups: "No hay búsquedas maps_get(\"defaults\", \"{key}\") en el lienzo",
  callAiResult: "Llamar a la IA: {applied} aplicados · {errors} errores{extra}",
  functionLibraryCount: "Biblioteca de funciones: {n} {functions}",
  functionSingular: "función",
  functionPlural: "funciones",
  renamedFromParen: " (renombrada desde {name})",
  savedBundle: "Guardado {name}",
  descriptionForFunction: "Descripción de la función \"{name}\" (opcional):",
  clashExist: "{bits} ya existen. Renombrar conserva ambas (predeterminado). Reemplazar sobrescribe la definición existente.",
  functionQuoted: "Función \"{name}\"",
  decisionQuoted: "Tabla de decisión \"{name}\"",
  andWord: "y",
  openedContributionIssue: "Incidencia de contribución abierta para {name}",
  openedGithubForm: "Formulario de nueva incidencia de GitHub abierto para {name}",
  entrySummary: "{description} Parámetros: {params}. Tablas de decisión: {tables}.",
  recommendedFrozen: "Está usando intEHRgrator {current}, que no es la versión recomendada para usuarios finales ({recommended}).",
  recommendedBleeding: "Está usando la compilación más reciente (se actualiza con cada cambio en main), no la versión estable recomendada ({recommended}).",
  goToRecommended: "Ir a la versión recomendada ({tag})",
  previewingSeq: "Previsualizando la sec {n}…",
  previewLoadedSeq: "Vista previa cargada para la sec {n} (solo lectura; el lienzo principal no cambia).",
  rollbackAsk: "¿Revertir a la sec {seq}?\n\nSe descartarán {n} entradas posteriores.\n\n¿Descargar la rama descartada (.intehrgrator) antes de continuar?",
  confirmRollback: "¿Confirmar la reversión destructiva a la sec {seq}?",
  rolledBackSeq: "Revertido a la sec {n}. El lienzo principal se sincronizará.",
  patchPromptCopied: "Prompt de parche copiado (intehrgrator-suggestions v2). Aplicar con import_suggestions.",
  optionalAttributes: "Atributos opcionales…",
  openViewerMenu: "Abrir ventana de visor…",
  noAgentsYet: "Aún no hay agentes conectados.",
  aiChatHistoryTrimmed: "Se quitaron turnos antiguos del chat para que la petición quede dentro de {limit} tokens (la API reenvía todo el chat en cada paso); este mensaje vuelve a adjuntar el contexto del proyecto.",
  aiChatHistoryFull: "No se envió nada: el historial del chat tiene unos {tokens} tokens, por encima del límite de {limit} de este modelo, y todo el historial va con cada petición. ¿Cómo quiere continuar?",
  aiChatHistoryTrimChoice: "Continuar con el historial recortado",
  aiChatHistoryRecapChoice: "Empezar un chat nuevo con resumen",
  aiChatHistoryCancelChoice: "Cancelar",
  aiChatHistoryRecapStarted: "Chat nuevo iniciado. Un resumen del chat anterior (sus mensajes, las respuestas y los mapeos) va con su mensaje, junto con el contexto del proyecto.",
  aiChatHistoryCancelled: "No enviado. Su mensaje sigue en el cuadro.",
  aiChatStorageTrimmed: "Este chat es mayor de lo que guarda el navegador ({limit} caracteres). Esta página conserva todo el chat, pero al recargar solo quedan los turnos más recientes.",
};
